import { WifiOff, RefreshCw, Check, CloudUpload } from "lucide-react";
import { useSync } from "@/context/SyncContext";
import { useLang } from "@/context/LanguageContext";

/** "Offline / Saving locally / Syncing / Synced" chip shown in the sidebar & mobile header. */
export default function SyncStatusBadge() {
  const sync = useSync();
  const { t } = useLang();
  if (!sync) return null;
  const { online, pending, syncing, justSynced, runSync } = sync;

  if (!online) {
    return (
      <span data-testid="sync-status-offline" className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-100 text-amber-800 text-[11px] font-medium">
        <WifiOff size={12} strokeWidth={2} />
        {t("syncOffline")}{pending > 0 ? ` · ${pending}` : ""}
      </span>
    );
  }
  if (syncing) {
    return (
      <span data-testid="sync-status-syncing" className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-sky-100 text-sky-800 text-[11px] font-medium">
        <RefreshCw size={12} strokeWidth={2} className="animate-spin" />
        {t("syncSyncing")}
      </span>
    );
  }
  if (pending > 0) {
    return (
      <button
        data-testid="sync-status-pending"
        onClick={runSync}
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-sky-100 text-sky-800 text-[11px] font-medium hover:bg-sky-200 transition-colors"
      >
        <CloudUpload size={12} strokeWidth={2} />
        {t("syncPending").replace("{n}", String(pending))}
      </button>
    );
  }
  if (justSynced) {
    return (
      <span data-testid="sync-status-synced" className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-100 text-emerald-800 text-[11px] font-medium">
        <Check size={12} strokeWidth={2} />
        {t("syncSynced")}
      </span>
    );
  }
  return (
    <span data-testid="sync-status-online" className="inline-flex items-center gap-1.5 text-[11px] text-stone-400">
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block" />
      {t("syncOnline")}
    </span>
  );
}
